import { translateField } from "@cdv/jazz-i18n";
import { Button, Stack, Typography } from "@mui/material";
import { ReactElement, useContext } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { useNavigate } from "react-router";
import { AppContext } from "@cdv/jazz-ui";

export default function Content(): ReactElement {
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);
  return (
    <>
      <AppBar title={translateField(Resource.Game, "title")} />

      <Stack sx={{ justifyContent: "center", minHeight: "78vh", mt: "0 !important" }} spacing={2}>
        <Stack sx={{ alignItems: "center" }}>
          <img src="/assets/06_ilustr_hry.svg" style={{ height: 216 }} />
        </Stack>

        <Typography sx={{ textAlign: "center" }}>
          Volná trasa pro relax. <br /> Tady se hraje podle <br /> tvých pravidel!
        </Typography>

        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <Button
            variant="contained"
            size="large"
            sx={{ width: "211px" }}
            onClick={() => navigate(getUrl(Resource.GameAnt))}
          >
            HRA MRAVENCI
          </Button>
        </Stack>
      </Stack>
    </>
  );
}
